
import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../../common/services/cqs/IPrimaryKey";

export class ChangeAtgardTypCommand extends BasicCommand<ChangeAtgardTypCommand> {
    atgardGuid: string;
    atgardTyp: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ChangeAtgardTypCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "ChangeAtgardTyp";

    get primaryKey(): IPrimaryKey<ChangeAtgardTypCommand> {
        return {
            atgardGuid: this.atgardGuid
        };
    }

    constructor(atgardGuid: string, atgardTyp: string) {
        super(ChangeAtgardTypCommand.$type, ChangeAtgardTypCommand.$groupKey, CommandType.Insert);
        this.atgardGuid = atgardGuid;
        this.atgardTyp = atgardTyp;
    }
}
